(() => {
	// TODO: Create global helpers for toggling classes
	function removeActiveClasses(allEls) {
		allEls.forEach(el => {
			let activeClass = `${el.classList[0]}--active`;

			if (el.classList.contains(activeClass)) {
				el.classList.remove(activeClass);
			}
		});
	}
	function toggleClasses(nodeArr) {
		nodeArr.forEach(node => {
			// assumes that the first class is the class which has an active modifier
			let activeClass = `${node.classList[0]}--active`;

			if (!node.classList.contains(activeClass)) {
				node.classList.add(activeClass);
			}
		});
	}

	const tabs = [...document.querySelectorAll('.productdetails__tab, .pdp-tabnavigation__item')];
	const tabsContent = [...document.querySelectorAll('.productdetails__content, .pdp-tabcontent__item')];

	tabs.forEach(tab => {
		tab.addEventListener('click', () => {
			let datasetVal = tab.dataset.tab;
			if(!datasetVal) return;

			removeActiveClasses([...tabs, ...tabsContent]);

			if (datasetVal) {
				tabsContent.forEach(content => {
					if (datasetVal == content.dataset.tabContent) {
						toggleClasses([tab, content]);
					}
				});
			}
		});
	});

	const addtocartBtns = document.querySelectorAll('.js-add-to-cart');
	if (addtocartBtns.length > 0) {
		addtocartBtns.forEach(btn => {
			const quantity = btn.dataset.quantity || 1;
			btn.addEventListener('click', e => {
				e.preventDefault();
				// Replaced store.dispatch with eventBus because of reactivity conflicts.
				window.EventBus.$emit('add-product', {
					event: e,
					product: {
						productId: btn.dataset.productid, 
						variantId: btn.dataset.variantid, 
						quantity: quantity
					}
				});
			});
		});
	}

	const showMoreElements = document.querySelectorAll('.pdp-specifications-info__wrapper');

	if(showMoreElements.length > 0) {
		showMoreElements.forEach(element => {
			const content = element.querySelector('.pdp-specifications-info__body');
			const bottomGradient = element.querySelector('.pdp-specifications-info__showmoregradient');
			const showMoreWrapper = element.querySelector('.pdp-specifications-info__showmore');
			const showMoreButton = element.querySelector('.pdp-button--showmore');
			const showLessButton = element.querySelector('.pdp-button--showless');
			let originalHeight = content.offsetHeight;
			let newHeight = 350;

			document.fonts.ready.then(function () {
				originalHeight = content.offsetHeight;
				
				if (newHeight >= originalHeight) {
					newHeight = originalHeight;
					showMoreWrapper.style.display = 'none';
				}
				
				content.style.maxHeight = newHeight + 'px';
			});
			
			showMoreButton.addEventListener('click', function () {
				showMoreWrapper.classList.add('pdp-specifications-info__showmore--active');
				content.style.maxHeight = originalHeight + 'px';
				showMoreButton.style.display = 'none';
				showLessButton.style.display = 'flex';
				bottomGradient.style.opacity = '0';
			});

			showLessButton.addEventListener('click', function () {
				showMoreWrapper.classList.remove('pdp-specifications-info__showmore--active');
				content.style.maxHeight = newHeight + 'px';
				showMoreButton.style.display = 'flex';
				showLessButton.style.display = 'none';
				bottomGradient.style.opacity = '1';
			});
		});
	}

	const toggles = document.querySelectorAll('.product-specifications__toggle');
	
	const openTab = e => {
		const target = e.target;
		const category = target.closest('.product-specifications__category');
		const specificationsList = category.querySelector(`#${target.getAttribute('aria-controls')}`);

		if(target.getAttribute('aria-selected') === 'true') {
			target.setAttribute('aria-selected', false);
			specificationsList.style.maxHeight = 0;
		} else {
			target.setAttribute('aria-selected', true);
			specificationsList.style.maxHeight = specificationsList.scrollHeight + 'px';
		}
	};

	toggles.forEach(toggle => {
		toggle.addEventListener('click', openTab);
	});

	window.addEventListener('load', () => {
		const specificationLists = document.querySelectorAll('.product-specifications__list');

		specificationLists.forEach(category => {
			const toggleButton = document.querySelector(`[aria-controls="${category.id}"]`);
			
			if(toggleButton) {
				const isSelected = toggleButton.getAttribute('aria-selected') === 'true';
				
				if(isSelected) {
					category.style.maxHeight = category.scrollHeight + 'px';
				} else {
					category.style.maxHeight = 0;
				}
			}
		});
	});

})();
